<template>
  <div>
    <Breadcrumb msg1="会员管理" msg2="会员标签" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="8">
          <el-button type="success" icon="el-icon-plus" @click="addTag">新建标签</el-button>
          <el-button type="primary" icon="el-icon-user" @click="openRel">给会员打标签</el-button>
        </el-col>
      </el-row>
      <el-table :data="tags" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="标签名称" prop="name" width="200"></el-table-column>
        <el-table-column label="颜色" width="120">
          <template slot-scope="scope">
            <el-tag :color="scope.row.color" style="color: #fff">{{ scope.row.color }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editTag(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delTag(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="tagDialogTitle" :visible.sync="tagShow" width="420px" :close-on-click-modal="false">
      <el-form :model="tagForm" label-width="80px">
        <el-form-item label="名称" required><el-input v-model="tagForm.name"></el-input></el-form-item>
        <el-form-item label="颜色">
          <el-color-picker v-model="tagForm.color"></el-color-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="tagShow = false">取消</el-button>
        <el-button type="primary" @click="saveTag">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="给会员打标签" :visible.sync="relShow" width="480px" :close-on-click-modal="false">
      <el-form :model="relForm" label-width="80px">
        <el-form-item label="会员" required>
          <el-select v-model="relForm.member_id" filterable remote placeholder="输入手机号搜索" :remote-method="searchMember" style="width: 100%">
            <el-option v-for="m in memberOptions" :key="m.member.id" :label="(m.customer ? m.customer.name : '') + ' ' + (m.customer ? m.customer.phone : '')" :value="m.member.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签" required>
          <el-select v-model="relForm.tag_id" style="width: 100%">
            <el-option v-for="t in tags" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="relShow = false">取消</el-button>
        <el-button type="primary" @click="saveRel">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      tags: [],
      tagShow: false,
      tagDialogTitle: '',
      tagForm: {},
      relShow: false,
      relForm: { member_id: null, tag_id: null },
      memberOptions: []
    }
  },
  created () { this.getTags() },
  methods: {
    getTags () {
      this.$axios.http.get('/memberTags').then(r => {
        if (r.data.status === 200) this.tags = r.data.data || []
      })
    },
    addTag () {
      this.tagDialogTitle = '新建标签'
      this.tagForm = { name: '', color: '#409EFF' }
      this.tagShow = true
    },
    editTag (row) {
      this.tagDialogTitle = '编辑标签'
      this.tagForm = Object.assign({}, row)
      this.tagShow = true
    },
    saveTag () {
      if (!this.tagForm.name) { this.$message.warning('名称必填'); return }
      if (this.tagForm.id) {
        this.$axios.put(`/memberTags/${this.tagForm.id}`, () => { this.tagShow = false; this.getTags() }, this.tagForm)
      } else {
        this.$axios.post('/memberTags', () => { this.tagShow = false; this.getTags() }, this.tagForm)
      }
    },
    delTag (id) {
      this.$axios.del(`/memberTags/${id}`, () => this.getTags())
    },
    openRel () {
      this.relForm = { member_id: null, tag_id: null }
      this.relShow = true
    },
    searchMember (kw) {
      if (!kw) return
      this.$axios.http.get('/members', { params: { page: 1, limit: 20, keyword: kw } }).then(r => {
        if (r.data.status === 200) this.memberOptions = r.data.data.records || []
      })
    },
    saveRel () {
      if (!this.relForm.member_id || !this.relForm.tag_id) { this.$message.warning('请选择会员和标签'); return }
      this.$axios.post('/memberTags/rel', () => { this.relShow = false; this.$message.success('已打标签') }, this.relForm)
    }
  }
}
</script>
